import React, { useState } from 'react';
import {
  Box,
  Button,
  Container,
  Field,
  Image,
  Input,
  Heading,
  VStack,
  Text,
} from '@chakra-ui/react';
import { useAuth } from '../context/AuthContext';
import { useNavigate } from 'react-router-dom';
import { toast } from '../utils/toast';

const Login: React.FC = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email, password);
      const stored = localStorage.getItem('user');
      const u = stored ? JSON.parse(stored) : null;
      if (u?.mustChangePassword) {
        navigate('/change-password-required');
      } else {
        navigate('/dashboard');
      }
    } catch (error: any) {
      toast({
        title: 'Error',
        description: error.response?.data?.message || 'Login failed',
        status: 'error',
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box
      minH="100vh"
      display="flex"
      alignItems="center"
      justifyContent="center"
      bg="gradient-to-br"
      style={{
        background: 'linear-gradient(135deg, #273f96 0%, #1369b3 100%)',
      }}
      px={4}
    >
      <Container maxW="md">
        <Box
          bg="white"
          p={10}
          borderRadius="2xl"
          boxShadow="2xl"
          borderWidth={0}
        >
          <VStack gap={6} align="stretch">
            <Box textAlign="center" mb={6}>
              <Image
                src="/NS_Projects.png"
                alt="Northstar Projects"
                mb={4}
                boxSize="200px"
                mx="auto"
                objectFit="contain"
              />
              <Heading size="2xl" mb={2} bgGradient="to-r" gradientFrom="#273f96" gradientTo="#1369b3" style={{ WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent' }}>
                Northstar Projects
              </Heading>
              <Text color="gray.600" fontSize="lg">
                Welcome back! Please login to continue.
              </Text>
            </Box>
            
            <form onSubmit={handleSubmit}>
              <VStack gap={5}>
                <Field.Root required>
                  <Field.Label fontSize="sm" fontWeight="semibold" color="gray.700">
                    Email Address
                  </Field.Label>
                  <Input
                    type="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    placeholder="your@email.com"
                    size="lg"
                    borderRadius="lg"
                    borderColor="gray.300"
                    _focus={{ borderColor: 'blue.500', boxShadow: '0 0 0 1px var(--chakra-colors-blue-500)' }}
                  />
                </Field.Root>
                
                <Field.Root required>
                  <Field.Label fontSize="sm" fontWeight="semibold" color="gray.700">
                    Password
                  </Field.Label>
                  <Input
                    type="password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    placeholder="Enter your password"
                    size="lg"
                    borderRadius="lg"
                    borderColor="gray.300"
                    _focus={{ borderColor: 'blue.500', boxShadow: '0 0 0 1px var(--chakra-colors-blue-500)' }}
                  />
                </Field.Root>
                
                <Button
                  type="submit"
                  width="100%"
                  size="lg"
                  loading={loading}
                  bgGradient="to-r"
                  gradientFrom="#273f96"
                  gradientTo="#1369b3"
                  color="white"
                  borderRadius="lg"
                  _hover={{
                    transform: 'translateY(-2px)',
                    boxShadow: 'xl',
                  }}
                  fontWeight="semibold"
                  fontSize="md"
                >
                  Sign In
                </Button>
              </VStack>
            </form>
          </VStack>
        </Box>
      </Container>
    </Box>
  );
};

export default Login;
